import { FONT_FAMILY } from 'styles/typography'

const baseLabelStyles = {
  fontFamily: FONT_FAMILY,
  padding: 10,
  stroke: 'transparent'
}

const centeredLabelStyles = {
  textAnchor: 'middle',
  ...baseLabelStyles
}

const themeStyles = Colors => {
  return {
    container: {
      maxWidth: 600,
      maxHeight: 500,
      margin: '0 auto'
    },
    area: {
      data: {
        fill: Colors.normalRangeGreen,
        fillOpacity: 0.5
      }
    },

    axis: (num) => ({
      axis: {
        fill: 'transparent',
        stroke: Colors.approxBlack,
        strokeWidth: 1
      },
      axisLabel: {
        ...centeredLabelStyles,
        padding: 25
      },
      grid: {
        fill: 'none',
        stroke: 'none',
        pointerEvents: 'painted'
      },
      tickLabels: {
        ...baseLabelStyles,
        fontSize: num > 7 ? '13px' : '14px',
        fill: Colors.approxBlack
      }
    }),

    line: {
      data: {
        stroke: Colors.primary
      }
    },

    scatter: {
      data: {
        stroke: 'transparent',
        strokeWidth: 0
      },
      labels: { fontFamily: FONT_FAMILY, fill: Colors.approxBlack, fontSize: 12 }
    },

    tooltip: {
      ...baseLabelStyles,
      padding: 0,
      pointerLength: 150
    },

    flyoutStyle: {
      stroke: Colors.approxBlack,
      strokeWidth: 1,
      fill: Colors.lighterSmoke
    },
    modalDisableTouch: {
      touchAction: 'none'
    }
  }
}

export default themeStyles
